import { Autocomplete, TextField } from "@mui/material";

import useDebouncedState from "~/shared/hooks/useDebouncedState";

import useFieldworkerSelect_GetAutocompleteOptions from "./api/useFieldworkerSelect_GetAutocompleteOptions";

type FieldworkerSelectProps = {
    label: string;
    value?: string[] | null;
    onChange: (value: string[]) => void;
};

export default function FieldworkerSelect({ label, value, onChange }: FieldworkerSelectProps) {
    const [searchQuery, debouncedSearchQuery, setSearchQuery] = useDebouncedState("");

    const { options, selectedOptions, loading } = useFieldworkerSelect_GetAutocompleteOptions({
        q: debouncedSearchQuery,
        selectedIds: value,
    });

    return (
        <Autocomplete
            multiple
            options={options}
            isOptionEqualToValue={(option, selected) => option.value === selected.value}
            loading={loading}
            getOptionKey={option => option.value}
            getOptionLabel={option => option.label}
            value={selectedOptions}
            onChange={(_, newValue) => onChange(newValue.map(x => x.value))}
            inputValue={searchQuery}
            onInputChange={(_, newInputValue, reason) => {
                if (reason === "reset") return;
                setSearchQuery(newInputValue);
            }}
            renderInput={params => <TextField {...params} fullWidth variant="outlined" label={label} />}
        />
    );
}
